import { OpDataType } from '../../models/core/op-data-type'
import { OpDataList } from '../../models/util'
import { OpDashboardData } from '../../models/custom'

export class ActiveViewColumnModel {
	caption: string;
	dataType: any;
	idDataType: number;
	idKeyViewColumn: number;
	idViewColumn: number;
	idViewColumnType: number;
	indexNbr: number;
	name: string;
	primaryKey: boolean;
	table: string;
}
export class ActiveViewModel {
	caption: string;
	columns: ActiveViewColumnModel[];
	id: number;
	idReferenceType: number;
}
export class ActivityModel {
	idActivity: number;
	idModule: number;
	idOperatorActivity: number;
	idReferenceType: number;
	referenceValue: any;
	allow: boolean;
}
export class AlarmDefGroupModel {
	defValue: string;
	idAlarmDef: number;
	idAlarmGroup: number;
	idTransmissionType: number;
	opState: number;
	value: string;
}
export class AlarmDefModel {
	currentAlarmDefGroups: AlarmDefGroupModel[];
	id: number;
	idAlarmText: number;
	idAlarmType: number;
	idDataTypeAlarm: number;
	idDataTypeConfig: number;
	indexNbr: number;
	isEnabled: boolean;
	name: string;
	opState: number;
	systemAlarmValue: any;
}
export class AlarmMessageModel {
	alarmStatus: string;
	operator: string;
	transmissionType: string;
}
export class ColumnModel {
	alignment: string;
	allowEditing: boolean;
	caption: string;
	hint: string;
	cellTemplate: string | any;
	chartType: string;
	editCellTemplate: any;
	format: any;
	hidden: boolean;
	id: number;
	idName: string;
	isEditable: boolean;
	lookup: any;
	name: string;
	position: number;
	referenceTypeId: number;
	sortDesc: boolean;
	skipTranslation: boolean
	type: number;
	typeName: string;
	unitId: number;
	unitName: string;
	where: string[];
	width: number;
	dataType: OpDataType;
	groupIndex: number;
	allowGrouping: boolean;
    calculateCellValue: (data: any) => any;
    selectedFilterOperation: string;
    showInColumnChooser: boolean = true;
    /** Niektore kolumny chcemy ukrywac w gridzie zawsze - VIEW_COLUMN_IS_HIDDEN - ale kolumna musi fizycznie istniec */
	alwaysHidden: boolean;
	editorOptions: any
	validationRules: any[]
}
export class ContextListModel {
	destinationType: number;
	referenceValues: any[];
	sourceType: number;
}
export class CorrespondingActionTypeModel {
	fields: FieldModel[];
	id: number;
	isActionDataFixed: boolean;
	name: string;
	referenceValues: number[];
	type: number;
}
export class CorrespondingActionTypeRequestModel {
	referenceValues: number[];
	type: number;
}
export class DashboardColumnModel {
	borderVisible: boolean;
	descr: DescrModel;
	groupId: number;
	height: number;
	indexNbr: number;
	isTemplate: boolean;
	isApplied: boolean;
	items: DashboardItemModel[];
	module: number;
	opState: number;
	refreshPeriod: number;
	size: number;
	title: string;
	sizeX: number;
	sizeY: number;
	column: number;
}
export class DashboardItemModel {
	configurationSourceLevel: number;
	data: DashboardDataModel;
	databaseType: number;
	descr: DescrModel;
	id: number;
	indexNbr: number;
	isCustomizable: boolean;
	opState: number;
	procedure: string;
	script: string;
	size: number;
	title: string;
	type: number;
	fontColor: string;
}
export class DashboardModel {
	configurationSourceId: number;
	configurationSourceLevel: number;
	descriptions: { [key: number]: DescrModel };
	files: FileModel[];
	fitToScreen: boolean;
	id: number;
	idDashboard: number;
	keepAspectRatio: boolean;
	margin: number[];
	maxHeight: number;
	maxWidth: number;
	name: string;
	nameDescriptions: DescrModel;
	opState: number;
	padding: number[];
	rows: DashboardRowModel[];
	useMargin: boolean;
	usePadding: boolean;
	width: number;
	backgroundColor: string;
	idStartupIndicator: number;
	type: number;
	dataList: OpDashboardData[];
}
export class DashboardRequestModel {
	groupId: number;
	idDashboard: number;
	ids: number[];
}
export class DashboardRowModel {
	columns: DashboardColumnModel[];
}
export class DataTypeFormat {
	datetimeFormat: string;
	idDataTypeFormat: number;
	numberMaxValue: number;
	numberMinValue: number;
}
export class DataTypeFormatGroupModel {
	dataTypeFormatOut: DataTypeFormat;
	format: string;
	idDataFormatGroup: number;
	idDataFormatOut: number;
	idDataType: number;
	idDataTypeClass: number;
	idDataTypeClassName: string;
}
export class DataTypeGroupModel {
	idDataTypeGroup: number;
	idParentGroup: number;
	idReferenceType: number;
	name: string;
	referenceValue: any;
}
export class DataTypeInGroupModel {
	description: string;
	idDataType: number;
	order: number;
}
export class DataTypeModel {
	caption: string;
	dataTypeClass: string;
	defaultValue: any;
	format: FormatModel;
	idDataType: number;
	isEditable: boolean;
	name: string;
	opState: number;
	referenceTypeId: number;
	type: number;
	typeName: string;
	unitId: number;
	unitName: string;
}
export class DefGroupsModel {
	defId: number;
	groups: SingleGroup[];
	removedGroups: SingleGroup[];
}
export class DepositoryContentModel {
	idLocation: number;
	idOperator: number;
	locationEquipment: OperatorLocationEquipmentModel[];
}
export class DescrModel {
	allLanguagesDescription: DescrModel[];
	description: string;
	idDescr: number;
	idLanguage: number;
	opState: number;
}
export class DeviceActionsModel {
	serialNumbers: number[];
}
export class DeviceDepositoryModel {
	address: string;
	devices: DeviceModel[];
	idLocation: number;
	latitude: number;
	longitude: number;
	name: string;
}
export class DeviceHierarchyModel {
	active: boolean;
	device: string;
	deviceId: number;
	hasErrorCode: number;
	id: number;
	protocolIn: string;
	protocolOut: string;
	referenceId: number;
	slotNbr: number;
	slotType: string;
}
export class DeviceMeterModel {
	idMeter: number;
	serialNbr: number;
}
export class DevicesEditModel {
	devices: DeviceHierarchyModel[];
	id: number;
}
export class DevicesForChangeModel {
	idLocation: number;
	serialNumbers: number[];
}
export class DictionaryModel {
	dataTypeGroups: DataTypeGroupModel[];
	dataTypeInGroups: any;
	dataTypes: any;
	distributors: ColumnModel[];
	modules: ColumnModel[];
	referenceIds: number[];
	references: { [key: number]: ColumnModel[] };
	units: ColumnModel[];
	views: any;
}
export class EntityModel {
	detailsFields: FieldModel[];
	errorMessage: string;
	fields: FieldModel[];
	hasErrorCode: number;
	id: number;
	markerString: string;
	name: string;
	referenceId: number;
}

export class FieldModel {
	caption: string;
	format: FormatModel;
	id: number;
	idDataType: number;
	index: number;
	isEditable: boolean;
	name: string;
	referenceTypeId: number;
	rowColor: number;
	type: string;
	typeId: number;
	unitName: string;
	value: any;
	valueReferenceId: any;

	public static getFieldModel(idDataType: number, value: any): FieldModel {
		const model: FieldModel = new FieldModel()
        model.index = 0
        model.idDataType = idDataType
        model.value = value
        model.typeId = 0
        return model
	}
}

export class FieldNameValueModel {
	id: number;
	idDataType: number;
	index: number;
	nameId: number; // TODO: NIE UŻYWAĆ W NOWYCH MIEJSCACH - NIE USUWAĆ DOPÓKI NIE PRZESTANIEMY CALKOWICIE KORZYSTAĆ Z CIENKIEGO KLIENTA - UŻYWANE W MASOWEJ EDYCJI LOKALIZACJI
	state: number;
	value: any;
}
export class FileModel {
	description: string;
	extension: string;
	fileBytes: string;
	fileBytesObj: any;
	id: number;
	insertDate: Date;
	isBlocked: boolean;
	lastDownloaded: Date;
	opState: number;
	parentEntityId: number;
	physicalFileName: string;
	size: number;
	version: string;
}
export class FormatModel {
	dateTimeFormat: string;
	isRequired: boolean;
	numberMaxPrecision: number;
	numberMaxScale: number;
	numberMaxValue: number;
	numberMinPrecision: number;
	numberMinScale: number;
	numberMinValue: number;
	textMaxLength: number;
	textMinLength: number;
}
export class FormValuesModel {
	addedValues: number[];
	fields: FieldNameValueModel[];
	id: number;
	removedValues: number[];
	values: number[];
}
export class GeneratedReportModel {
	id: number;
	reportType: number;
	resultString: string;
}
export class GridModel {
	errorMessage: string;
	hasErrorCode: number;
	totalCount: number;
	values: any;
}
export class GridRequestModel {
	columns: ColumnModel[];
	pageNumber: number;
	pageSize: number;
	where: string;
}
export class GroupModel {
	builtin: boolean;
	distributor: string;
	hasErrorCode: number;
	id: number;
	name: string;
	referenceId: number;
}
export class GroupRequestModel {
	columns: ColumnModel[];
	idLocations: number[];
	where: string;
}
export class HistoryModel {
	description: string;
	eventDate: Date;
	eventObject: any;
	eventType: string;
	hasErrorCode: number;
	longDescription: string;
	objectHistoryEventType: number;
}
export class HistoryTaskModel {
	endDate: Date;
	hasErrorCode: number;
	id: number;
	idOperator: number;
	idTask: number;
	idTaskStatus: number;
	notes: string;
	operatorDesc: string;
	startDate: Date;
	taskStatusDesc: string;
}
export class ImportDataModel {
	data: any[][];
	dllName: string;
	fileName: string;
	headers: string[];
	isDifferentFormat: boolean;
	needValidate: boolean;
	params: ImportPluginParam[];
}
export class ImportItemSummaryModel {
	description: string;
	importStatus: number;
	key: any;
}
export class ImportPluginModel {
	description: string;
	extensions: string[];
	idReferenceType: number;
	name: string;
	params: ImportPluginParam[];
	workType: any;
}
export class ImportPluginParam {
	defaultValue: any;
	idDataType: number;
	isInputParam: boolean;
	isVisible: boolean;
	value: any;
}
export class ImportProgressModel {
	errorCount: number;
	hasErrorCode: number;
	itemsCount: number;
	proceedItemsCount: number;
	skippedCount: number;
	status: string;
	statusId: number;
	successCount: number;
	warningCount: number;
}
export class ImportStatusModel {
	errorMessage: string;
	guid: string;
	hasErrorCode: number;
	isCompleted: boolean;
	statuses: SingleStatusModel[];
}
export class ImportSummaryModel {
	dllName: string;
	errorMessage: string;
	fileName: string;
	guid: string;
	hasErrorCode: number;
	importObject: any;
	importStatus: number;
}
export class LocationConfigurationProfileModel {
	appliedConfigurationProfile: string;
	appliedConfigurationProfileId: number;
	appliedDate: Date;
	appliedOperator: string;
	configurationProfile: string;
	configurationProfileId: number;
	idLocation: number;
	profileFunctionsList: ConfigurationProfileFunctionModel[];
	profilesTable: FieldModel[];
}
export class LocationEquipmentModel {
	device: string;
	endTime: Date;
	meter: string;
	startTime: Date;
}
export class LoginModel {
	distributors: number[];
	fakeSession: SessionModel;
	fakeUser: UserModel;
	locale: string;
	password: string;
	timeZone: string;
	user: string;
	key: string
}
export class LogoModel {
	id: number;
	jwt: string;
}
export class LPGKpiModel {
	aggregationPeriod: string;
	idLocation: number;
	idMeter: number;
	kpiName: string;
	value: { [key: number]: any };
}
export class LPGKpiRequestModel {
	aggregationPeriod: string;
	columns: ColumnModel[];
	dateFrom: Date;
	dateTo: Date;
	isRawData: boolean;
	locationIds: number[];
	meterIds: number[];
}
export class MeasurementCollectionModel {
	dataType: number;
	idLocation: number;
	idMeter: number;
	messures: MeasureModel[];
	serialNbr: number;
}
export class MeasurementModel {
	dataType: number;
	date: any;
	idLocation: number;
	idMeter: number;
	isDate: boolean;
	serialNbr: number;
	value: any;
}
export class MeasurementsModel {
	data: string;
	errorMessage: string;
	hasErrorCode: number;
}
export class MeasurementsRequestModel {
	aggregationPeriod: string;
	columns: ColumnModel[];
	dateFrom: Date;
	dateTo: Date;
	deviceIds: number[];
	gridColumns: ColumnModel[];
	isRawData: boolean;
	locationIds: number[];
	measurementViewStyle: number;
	meterIds: number[];
}
export class MeasureModel {
	date: any;
	isDate: boolean;
	value: any;
}
export class NotificationEntity {
	id: number;
	isEmailValue: boolean;
}
export class NotificationModel {
	distributorIds: number[];
	operatorId: number;
	referenceObjectId: number;
	referenceType: string;
	reset: NotificationEntity[];
	set: NotificationEntity[];
	type: string;
}
export class ObjectReferenceModel {
	id: number;
	referenceObjectId: number;
}
export class OperatorLocationEquipmentModel {
	device: DeviceModel;
	endTime: Date;
	idLocation: number;
	idLocationEquipment: number;
	idMeter: number;
	key: any;
	owner: any;
	serialNbr: number;
	startTime: Date;
}
export class OperatorSettingsModel {
	idOperator: number;
	isLogout: boolean;
	settings: string;
}
export class OperatorStringModel {
	customString: string;
	dataType: number;
}
export class OpResult {
	errorMessage: string;
	hasErrorCode: number;
	result: any;
}
export class PasswordResetEmailModel {
	locale: string;
	user: string;
}
export class PasswordResetModel {
	guid: string;
	locale: string;
	oldPassword: string;
	password: string;
}
export class PasswordResetResponseModel {
	hasErrorCode: number;
	message: string;
	status: string;
}
export class PaymentsFitterClientModel {
	additionalPayment: boolean;
	clientOrderedToPay: boolean;
	clientPaymentAmount: number;
	clientPaymentDate: Date;
	clientPaymentDone: boolean;
	currency: string;
	fitterOrderedToPay: boolean;
	fitterPaymentDate: Date;
	fitterPaymentDone: boolean;
	fitterVisitDate: Date;
	isClientPaymentsEdited: boolean;
	isFitterPaymentsEdited: boolean;
	paymentAmount: number;
	paymentNote: string;
	payments: PaymentsModel[];
}
export class PaymentsModel {
	element: string;
	indexNbr: number;
	notes: string;
	paymentType: number;
	value: number;
}
export class PlanDeliveryModel {
	deliveryDate: Date;
	locationIds: number[];
}
export class PointStateModel {
	added: boolean;
	loaded: boolean;
	modified: boolean;
	removed: boolean;
}
export class ProblemClassModel {
	id: number;
	idDescr: number;
	idProblemClass: number;
	name: string;
}
export class ProblemsRequestModel {
	locationIds: number[];
	problemIds: number[];
}
export class ReferenceTypeModel {
	referenceTypeId: number;
	tableName: number;
}
export class ResponseDeleteModel {
	errorMessage: string;
	hasErrorCode: number;
	result: boolean;
}
export class ResponseListModel<T> {
	errorMessage: string;
	hasErrorCode: number;
	result: T[];
}
export class ResponseModel {
	errorMessage: string;
	hasErrorCode: number;
}
export class ResponseValidateInfoModel {
	errorMessage: string;
	hasErrorCode: number;
	result: ValidateInfoModel[];
}
export class SaveFileModel {
	fileModel: FileModel;
	hasErrorCode: number;
	status: string;
}
export class SchemaElement {
	description: string;
	elementsApperance: SchemaElementApperance[];
	elementType: number;
	height: number;
	idDataType: number;
	isEditable: boolean;
	isUnitVisible: boolean;
	name: string;
	type: number;
	value: any;
	valueHidden: boolean;
	width: number;
	x: number;
	y: number;
}
export class SchemaElementApperance {
	color: string;
	condition: string;
	constraint1: any;
	constraint2: any;
	image: number[];
}
export class SchemaModel {
	errorMessage: string;
	hasErrorCode: number;
	height: number;
	idObject: any;
	referenceType: number;
	schema: number[];
	schemaConfiguration: SchemaElement[];
	width: number;
	class: number;
	indexNbr: number;
}
export class ScriptGuidFormModel {
	guid: string;
}
export class ScriptGuidModel {
	guid: string;
	hasErrorCode: number;
}
export class ScriptModel {
	arguments: ScriptParamModel[];
	authorId: number;
	authorName: string;
	content: string;
	description: string;
	idDBScript: number;
	name: string;
}
export class ScriptParamModel {
	defaultValue: any;
	fieldName: string;
	format: string;
	idDataTypeClass: number;
	idDBScript: number;
	idReference: number;
	idUnit: number;
	isCollection: boolean;
	isInputParam: boolean;
	isVisible: boolean;
	name: string;
	value: any;
}
export class ScriptResultModel {
	executionTime: string;
	gridDataSource: any[];
	gridNames: string[];
}
export class ScriptStatusModel {
	error: any;
	isScriptReady: boolean;
}
export class SecurityChangeModel {
	added: number[];
	customs: SecurityCustomActivityModel[];
	operatorId: number;
	removed: number[];
}
export class SecurityRoleModel {
	description: string;
	id: number;
	moduleName: string;
	name: string;
	valueString: string;
}
export class SessionModel {
	error: any;
	guid: string;
	imrWcfAddress: string;
	status: number;
	time: Date;
}
export class SimpleKeyValueModel {
	id: number;
	value: string;
}
export class SimpleValueModel<T> {
	value: T;
}
export class SingleGroup {
	idGroup: number;
	idTransmissionType: number;
}
export class SingleStatusModel {
	description: string;
	key: any;
	status: string;
	statusId: number;
}
export class SsrsReportRequestModel {
	currentPage: number;
	format: string;
	id: number;
	parameters: { [key: string]: string[] };
	searchText: string;
	subreportId: string;
}
export class TaskStatusChangeModel {
	statusId: number;
	taskIds: number[];
}
export class TaskStatusModel {
	id: number;
	name: string;
}
export class UserModel {
	avatar: string;
	id: number;
	idDistributor: number;
	name: string;
	permissions: string[];
	token: string;
	username: string;
}
export class ValidateInfoModel {
	message: string[];
	referenceType: number;
	referenceValue: any;
	status: number;
}
export class ValidationScriptModel {
	databaseType: number;
	text: string;
}
export class KeyValuePair<TKey, TValue> {
	key: TKey;
	value: TValue;
}
export class DashboardChartSeries {
	referenceType: number;
	seriesCaption: DescrModel;
	seriesColor: string;
	seriesName: string;
	seriesPoints: DashboardChartSeriesPoint[];
	seriesType: number;
	xCaption: DescrModel;
	xIdDataTypeFormat: number;
	xName: string;
	xType: string;
	xTypeName: string;
	yCaption: DescrModel;
	yIdDataTypeFormat: number;
	yName: string;
	yType: string;
	yTypeName: string;
}
export class DashboardChartSeriesPoint {
	referenceData: any[];
	xValue: any;
	yValue: any;
}
export class DashboardDataModel {
	id: number;
	fontColor: string;
	type: DescrModel;
}
export class DashboardGaugeRangesModel {
	color: string;
	maxValue: number;
	minValue: number;
	name: DescrModel;
}
export class DashboardGridColumnModel {
	caption: DescrModel;
	dataField: string;
	idDataTypeFormat: number;
	tooltip: DescrModel;
	type: string;
}
export class DashboardGridOption {
	caption: string;
	option: number;
	visible: boolean;
}
export class DashboardMapCoord {
	latitude: number;
	longitude: number;
}
export class DashboardMapLegendItem {
	color: string;
	description: DescrModel;
	icon: FileModel;
	iconId: number;
}
export class DashboardMapMarker {
	color: string;
	coords: DashboardMapCoord;
	icon: number[];
	iconIndex: number;
	iconUrl: string;
	id: number;
	tooltip: string;
}
export class DashboardMapPolygon {
	coords: DashboardMapCoord[];
	fillColor: string;
	lineColor: string;
	tooltip: string;
}
export class DashboardMapRange {
	coords: DashboardMapCoord;
	fillColor: string;
	lineColor: string;
	radius: number;
	tooltip: string;
}

// File is generated :)
export class ActionModel extends EntityModel {
}
export class ActionPacketDataModel extends EntityModel {
	dataType: number;
	index: number;
	status: string;
	time: Date;
	value: string;
}
export class ActionPacketModel extends EntityModel {
	address: string;
	direction: number;
	packetData: ActionPacketDataModel[];
	packetTime: Date;
	serialNumber: number;
	status: string;
	transmissionDriver: string;
}
export class AlarmGroupFormValuesModel extends FormValuesModel {
	addedOperators: number[];
	description: string;
	distributorId: number;
	isEnabled: boolean;
	name: string;
	operators: number[];
	removedOperators: number[];
}
export class AlarmGroupModel extends EntityModel {
	description: string;
	distributorId: number;
	isEnabled: boolean;
	operators: EntityModel[];
}
export class ConfigurationProfileFunctionModel extends EntityModel {
	deviceFunctionType: number;
	deviceFunctionTypeString: string;
	functionString: string;
	idConfigurationProfile: number;
	indexNbr: number;
}
export class ContactFormValuesModel extends FormValuesModel {
	groups: number[];
	locations: number[];
}
export class ContactModel extends EntityModel {
	groups: GroupModel[];
	locations: EntityModel[];
}
export class DashboardListModel extends EntityModel {
	dashboards: DashboardModel[];
}
export class DeviceConnectionModel extends EntityModel {
	deviceLat: number;
	deviceLon: number;
	parentLat: number;
	parentLon: number;
	serialNbr: number;
	serialNbrParent: number;
}
export class DeviceModel extends EntityModel {
	currentMeterId: number;
	currentMeterName: string;
	locations: GroupModel[];
	meters: EntityModel[];
}
export class DistributorModel extends EntityModel {
}
export class FileColumnModel extends FileModel {
	columns: ColumnModel[];
	params: ImportPluginParam[];
}
export class GridRequestReferenceModel extends GridRequestModel {
	idDataType: number;
	idReferenceType: number;
}
export class ImportDataResponseModel extends ResponseModel {
	result: ImportDataModel;
}
export class IssueModel extends EntityModel {
	idLocation: number;
	tasks: TaskModel[];
}
export class LocationFormValuesModel extends FormValuesModel {
	addedDevices: number[];
	addedGroups: number[];
	addedMeters: number[];
	deviceMeter: DeviceMeterModel[];
	devices: number[];
	deviceWithMeter: DeviceMeterModel[];
	groups: number[];
	locationToAssign: number;
	meters: number[];
	removedDevices: number[];
	removedGroups: number[];
	removedMeters: number[];
	removeWithDevices: boolean;
	removeWithMeters: boolean;
}
export class LocationModel extends EntityModel {
	allowGrouping: boolean;
	devices: DeviceModel[];
	groups: GroupModel[];
	history: HistoryModel[];
	latitude: number;
	locationId: number;
	longitude: number;
	markerColorReference: string;
	meters: MeterModel[];
	rowColor: string;
}
export class MeterFormValuesModel extends FormValuesModel {
	addedDevices: number[];
	alarmDefs: AlarmDefModel[];
	alarmGroups: DefGroupsModel[];
	currentAlarmDefs: AlarmDefModel[];
	currentLocation: number;
	devices: number[];
	removedAlarmDefs: number[];
	removedDevices: number[];
}
export class MeterModel extends EntityModel {
	alarmDefs: GridModel;
	alarmDefsCount: number;
	alarmGroups: GridModel;
	alarmGroupsCount: number;
	currentDeviceId: number;
	currentDeviceName: string;
	devices: EntityModel[];
	idMeterType: number;
	idMeterTypeClass: number;
}
export class ModelAlarm extends EntityModel {
	events: AlarmMessageModel[];
	latitude: number;
	longitude: number;
	message: string;
}
export class OperatorModel extends EntityModel {
	activities: GridModel;
	actorFields: FieldModel[];
	allActivities: GridModel;
	depositoryLocation: LocationModel;
	deviceDepository: DeviceDepositoryModel;
	notificationIssues: GridModel;
	notificationLocations: GridModel;
	notificationTasks: GridModel;
	notificationWorkOrders: GridModel;
	roles: GridModel;
}
export class PointModel extends PointStateModel {
	idLocation: number;
	idTask: number;
}
export class ProblemClasssesModel extends EntityModel {
	result: ProblemClassModel[];
}
export class ReportModel extends EntityModel {
	reportType: number;
}
export class RouteFormValuesModel extends FormValuesModel {
	addedOperators: number[];
	locations: PointModel[];
	operators: number[];
	removedOperators: number[];
}
export class RouteModel extends EntityModel {
	locations: EntityModel[];
	operators: EntityModel[];
	routeType: number;
}
export class ScheduleConfigurationModel extends ConfigurationProfileFunctionModel {
	dayOfMonth: number;
	dayOfWeek: number[];
	hourOfDay: number;
	isEnable: boolean;
	isLocalTime: boolean;
	minutesOfHour: number;
}
export class SecurityActivityModel extends ObjectReferenceModel {
	operatorId: number;
}
export class SecurityCustomActivityModel extends SecurityActivityModel {
	idOperatorActivity: number;
	isAdded: boolean;
	isRemoved: boolean;
	moduleId: number;
	uniqueRowId: number;
	allow: boolean;
}
export class ServicemanModel extends EntityModel {
	polygon: any;
	range: any;
}
export class SsrsReportModel extends EntityModel {
}
export class TaskFormValuesModel extends FormValuesModel {
	addedPayments: PaymentsModel[];
	payments: PaymentsModel[];
	paymentsInfo: PaymentsFitterClientModel;
	removedPayments: PaymentsModel[];
}
export class TaskModel extends EntityModel {
	idLocation: number;
	installedDevices: any[];
	paymentsInfo: PaymentsFitterClientModel;
	taskString: string;
	uninstalledDevices: any[];
}
export class UserFormValuesModel extends FormValuesModel {
	activities: number[];
	activitiesObj: ActivityModel[];
	actorFields: number[];
	allActivities: ActivityModel[];
	customActivities: SecurityCustomActivityModel[];
	customRoles: SecurityCustomActivityModel[];
	notificationIssues: NotificationEntity[];
	notificationLocations: NotificationEntity[];
	notificationTasks: NotificationEntity[];
	notificationWorkOrders: NotificationEntity[];
	roles: number[];
	userFields: number[];
}
export class DashboardCardDataModel extends DashboardDataModel {
	backgroundColor: string;
	header: string;
	image: FileModel;
	imageExtension: string;
	option: number;
	referenceData: any[];
	referenceType: number;
	referenceValue: number;
	text: string;
}
export class DashboardChartDataModel extends DashboardDataModel {
	chartTitle: DescrModel;
	correlationType: number;
	isTableVisible: boolean;
	referenceData: any[];
	referenceType: number;
	series: DashboardChartSeries[];
	titlePosition: number;
	axisGridColor: string;
	axisXColor: string;
	axisYColor: string;
	titleColor: string;
	tooltipBackgroundColor: string;
	tooltipValueColor: string;
	isLegendButtonHidden: boolean;
	isLegendValueVisible: boolean;
	isFullscreenButtonHidden: boolean;
	isSeriesLabelVisible: boolean;
	isTooltipHidden: boolean;
	isYAxisTitleHidden: boolean;
	isXAxisTitleHidden: boolean;
	isVerticalGridHidden: boolean;
	isHorizontalGridHidden: boolean;
	backgroundColor: string;
	startupSerie: string;
}
export class DashboardGaugeDataModel extends DashboardDataModel {
	label: DescrModel;
	max: number;
	min: number;
	ranges: DashboardGaugeRangesModel[];
	referenceData: any[];
	referenceType: number;
	value: any;
}
export class DashboardGridDataModel extends DashboardDataModel {
	buttonOptions: DashboardGridOption[];
	columns: DashboardGridColumnModel[];
	contextMenuEnabled: boolean;
	correlationType: number;
	dataSource: any[];
	headerTextAlign: number;
	referenceData: any[];
	referenceType: number;
	shortDetailsEnabled: boolean;
}
export class DashboardMapDataModel extends DashboardDataModel {
	correlationType: number;
	iconDict: { [key: number]: number[] };
	legendItems: DashboardMapLegendItem[];
	markers: DashboardMapMarker[];
	polygons: DashboardMapPolygon[];
	ranges: DashboardMapRange[];
	referenceData: any[];
	referenceType: number;
	shortDetailsEnabled: boolean;
	interaction: number;
}
export class DashboardSaveModel extends DashboardModel {
	destinationLevel: number;
	destinationObject: any;
}
export class DashboardSchemaDataModel extends DashboardDataModel {
	correlationType: number;
	referenceData: any[];
	referenceType: number;
	schemas: SchemaModel[];
}
export class DashboardTileDataModel extends DashboardDataModel {
	amountVisible: boolean;
	backgroundColor: string;
	backgroundImage: FileModel;
	borderColor: string;
	borderRadius: number[];
	borderWidth: number;
	hoverColor: string;
	icon: FileModel;
	iconVisible: boolean;
	isAmountADate: boolean;
	referenceData: any[];
	referenceType: number;
	selectColor: string;
	shadowBlurRadius: number;
	shadowColor: string;
	shadowHorizontalLenght: number;
	shadowSpreadRadius: number;
	shadowVerticalLenght: number;
	texHeaderVisible: boolean;
	textHeader: DescrModel;
	value: any;
	correlationType: number;
	iconPosition: number;
	titlePosition: number;
	valuePosition: number;
	iconStretch: number;
	titleSize: number;
	valueSize: number;
	titleColor: string;
	valueColor: string;
	gridsterSettings: string;
}